import { Reducer } from '@reduxjs/toolkit';
import { FluxStandardAction } from 'redux-promise-middleware';
import {
  LoadSheet,
  LoadSheetTemplate,
  LoadSheetPreviewData,
  Receiver,
  AccountEBPTemplates,
} from '../../../types/loadSheets';

export interface LoadSheetsState {
  loadSheets: LoadSheet[];
  selectedTemplate: LoadSheetTemplate | null;
  previewData: LoadSheetPreviewData | null;
  receivers: Receiver[];
  accountEBPTemplates: AccountEBPTemplates[];
  ebpPreviewColumns: any[];
  isLoading: boolean;
  fetchingTemplate: boolean;
  fetchingPreview: boolean;
  fetchingEbpColumns: boolean;
  error: string | null;
}

const initialState: LoadSheetsState = {
  loadSheets: [],
  selectedTemplate: null,
  previewData: null,
  receivers: [],
  accountEBPTemplates: [],
  ebpPreviewColumns: [],
  isLoading: false,
  fetchingTemplate: false,
  fetchingPreview: false,
  fetchingEbpColumns: false,
  error: null,
};

const reducer: Reducer<LoadSheetsState, FluxStandardAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_LOAD_SHEETS_PENDING': {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case 'FETCH_LOAD_SHEETS_FULFILLED': {
      return {
        ...state,
        isLoading: false,
        loadSheets: action.payload.data,
        error: null,
      };
    }
    case 'FETCH_LOAD_SHEETS_REJECTED': {
      return {
        ...state,
        isLoading: false,
        error: action.payload?.response?.data?.Error || action.payload?.response?.data?.message,
      };
    }
    case 'FETCH_LOAD_SHEET_TEMPLATE_PENDING': {
      return {
        ...state,
        fetchingTemplate: true,
        error: null,
      };
    }
    case 'FETCH_LOAD_SHEET_TEMPLATE_FULFILLED': {
      return {
        ...state,
        fetchingTemplate: false,
        selectedTemplate: action.payload.data,
        error: null,
      };
    }
    case 'FETCH_LOAD_SHEET_TEMPLATE_REJECTED': {
      return {
        ...state,
        fetchingTemplate: false,
        error: action.payload?.response?.data?.Error || action.payload?.response?.data?.message,
      };
    }
    case 'CREATE_LOAD_SHEET_REJECTED': {
      return {
        ...state,
        error: action.payload?.response?.data?.Error || action.payload?.response?.data?.message,
      };
    }
    case 'UPDATE_LOAD_SHEET_PENDING': {
      return {
        ...state,
        fetchingTemplate: true,
        error: null,
      };
    }
    case 'UPDATE_LOAD_SHEET_FULFILLED': {
      return {
        ...state,
        fetchingTemplate: false,
        error: null,
      };
    }
    case 'UPDATE_LOAD_SHEET_REJECTED': {
      return {
        ...state,
        error: action.payload?.response?.data?.Error || action.payload?.response?.data?.message,
        fetchingTemplate: false,
      };
    }
    case 'FETCH_LOAD_SHEET_PREVIEW_PENDING': {
      return {
        ...state,
        fetchingPreview: true,
        error: null,
      };
    }
    case 'FETCH_LOAD_SHEET_PREVIEW_FULFILLED': {
      return {
        ...state,
        fetchingPreview: false,
        error: null,
      };
    }
    case 'FETCH_LOAD_SHEET_PREVIEW_REJECTED': {
      return {
        ...state,
        fetchingPreview: false,
        error: action.payload?.response?.data?.Error || action.payload?.response?.data?.message,
      };
    }
    case 'SET_LOAD_SHEET_PREVIEW_DATA': {
      return {
        ...state,
        previewData: action.payload,
      };
    }
    case 'CLEAR_LOAD_SHEET_PREVIEW_DATA': {
      return {
        ...state,
        previewData: null,
      };
    }
    case 'FETCH_ACCOUNT_EBP_TEMPLATES_REJECTED': {
      return {
        ...state,
        accountEBPTemplates: [],
        error: action.payload?.response?.data?.Error || action.payload?.response?.data?.message,
      };
    }
    case 'FETCH_ACCOUNT_EBP_TEMPLATES_FULFILLED': {
      return {
        ...state,
        accountEBPTemplates: action.payload.data,
        error: null,
      };
    }
    case 'CLEAR_LOAD_SHEETS_ERROR': {
      return {
        ...state,
        error: null,
      };
    }
    case 'CLEAR_SELECTED_TEMPLATE': {
      return {
        ...state,
        selectedTemplate: null,
      };
    }
    case 'FETCH_LOAD_SHEET_PREVIEW_EBP_COLUMNS_PENDING': {
      return {
        ...state,
        fetchingEbpColumns: true,
        error: null,
      };
    }
    case 'FETCH_LOAD_SHEET_PREVIEW_EBP_COLUMNS_FULFILLED': {
      return {
        ...state,
        fetchingEbpColumns: false,
        ebpPreviewColumns: action.payload.data,
        error: null,
      };
    }
    case 'FETCH_LOAD_SHEET_PREVIEW_EBP_COLUMNS_REJECTED': {
      return {
        ...state,
        fetchingEbpColumns: false,
        error: action.payload?.response?.data?.Error || action.payload?.response?.data?.message,
      };
    }
  }
  return state;
};

export default reducer;
